import { render, staticRenderFns } from "./v-toggle.vue?vue&type=template&id=6a4a5d82&"
import script from "./v-toggle.vue?vue&type=script&lang=js&"
export * from "./v-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports